var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBacon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4002 3L29.8002 8.4L27.9002 10.4C27.4329 10.8514 27.0665 11.3967 26.8252 12C26.5839 12.6033 26.4731 13.2508 26.5002 13.9C26.5002 16.3 26.0002 20.1 23.0002 22.6C20.2932 24.6378 17.0737 25.8841 13.7002 26.2C12.6256 26.3985 11.624 26.882 10.8002 27.6L8.7002 29.8",
    fill: "url(#paint0_linear_20_753)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4002 3L29.8002 8.4L27.9002 10.4C27.4329 10.8514 27.0665 11.3967 26.8252 12C26.5839 12.6033 26.4731 13.2508 26.5002 13.9C26.5002 16.3 26.0002 20.1 23.0002 22.6C20.2932 24.6378 17.0737 25.8841 13.7002 26.2C12.6256 26.3985 11.624 26.882 10.8002 27.6L8.7002 29.8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70001 29.8L3 24.1L6.60004 20.6C7.37169 19.8064 8.39863 19.3106 9.5 19.2C11.4 19 14.4 18.4 16.3 16.7C18.2 15 19 11.3 19.4 9.2C19.5984 8.18445 20.0843 7.24728 20.8 6.5L24.4 3",
    fill: "url(#paint1_linear_20_753)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70001 29.8L3 24.1L6.60004 20.6C7.37169 19.8064 8.39863 19.3106 9.5 19.2C11.4 19 14.4 18.4 16.3 16.7C18.2 15 19 11.3 19.4 9.2C19.5984 8.18445 20.0843 7.24728 20.8 6.5L24.4 3",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 24.1C10.0045 23.17 11.2533 22.5456 12.6 22.3C14.5 22.1 17.5 21.5 19.4 19.7C21.3 17.9 22.1 14.4 22.5 12.3C22.873 11.0988 23.5239 10.0025 24.4 9.10001",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_753",
    x1: 8.77357,
    y1: 7.16808,
    x2: 33.7935,
    y2: 23.8198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26702"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_753",
    x1: 3.07442,
    y1: 7.16808,
    x2: 28.229,
    y2: 24.1474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26702"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacon);
export default __webpack_public_path__ + "static/media/bacon.26057a7b3e6a98c4a45173ba7eff5ada.svg";
export { ForwardRef as ReactComponent };